export const userReportsHeaders = [
  {
    label: "User Name",
    key: "userName",
  },
  {
    label: "Email",
    key: "email",
  },
  {
    label: "Pending Steps",
    key: "pendingSteps",
    classNameGetter: () => {
      return "panding-steps-column";
    },
  },
];

export const userReportsData = [
  {
    userName: "Jhon Doe",
    email: "jhondeo@gmail.com",
    pendingSteps: "Meeting Scheduled at 03:00 PM",
  },

  {
    userName: "Jhon Doe",
    email: "jhondeo@gmail.com",
    pendingSteps: "Meeting Scheduled at 03:00 PM",
  },
  {
    userName: "Jhon Doe",
    email: "jhondeo@gmail.com",
    pendingSteps: "Meeting Scheduled at 03:00 PM",
  },
  {
    userName: "Jhon Doe",
    email: "jhondeo@gmail.com",
    pendingSteps: "Meeting Scheduled at 03:00 PM",
  },
  {
    userName: "Jhon Doe",
    email: "jhondeo@gmail.com",
    pendingSteps: "Meeting Scheduled at 03:00 PM",
  },
  {
    userName: "Jhon Doe",
    email: "jhondeo@gmail.com",
    pendingSteps: "Meeting Scheduled at 03:00 PM",
  },
];
